const config = {
  url: window.location.hostname === 'slowpokecorner.com'
        ? 'https://slowpokecorner.com/'
       : 'https://slowpokecorner.com/',
  // fallback live-stream embed used when a rumble has no live_embed_url set
  liveChannelEmbedUrl: 'https://www.youtube.com/embed/live_stream?channel=UCEAm1Eogkl1npeYVqR1j5Ww',
  }

export default config;